//域名统一管理
const BASE_URL = {
    // devUrl: 'http://test-yaokangfu-api.yaojixin.com',// 本地环境地址
    // devUrl: 'http://yaokangfu-api.yaojixin.com', // 本地环境地址  
    devUrl: 'http://192.168.1.186:9202',
    testUrl: 'http://test-yaokangfu-api.yaojixin.com',// 测试环境地址
    productUrl: 'http://yaokangfu-api.yaojixin.com' // 生产地址
}
const SMS_URL = {
    devUrl: 'http://sms.yaojixin.com', // 本地环境地址
    // devUrl: 'http://192.168.0.36:9009', // 本地环境地址
    testUrl: 'http://test-sms.yaojixin.com', // 测试环境地址
    productUrl: 'http://sms.yaojixin.com' // 生产地址

}
/** 首页实时数据 WebSocket（ruoyi-websocket，与 HTTP 业务地址分开配置）
 * 开发可直连网关 9202，或直连节点 9206；连上后若马上断开，看控制台 [HomeWS] */
const WS_URL = {
    // 经网关：ws://{网关}:9202 ；直连节点：ws://{节点}:9206
    // devUrl: 'ws://192.168.1.251:9206',
    // devUrl: 'ws://192.168.1.251:9202',
    devUrl: 'wss://yaokangfu-api.yaojixin.com', 



    testUrl: 'wss://test-yaokangfu-api.yaojixin.com',
    productUrl: 'wss://yaokangfu-api.yaojixin.com'
}
let baseUrl = "";   //这里是一个默认的url，可以没有
let smsUrl = "";
let wsUrl = "";
switch (process.env.NODE_ENV) {
    case 'development': // dev 本地
        baseUrl = BASE_URL.devUrl;
        smsUrl = SMS_URL.devUrl;
        wsUrl = WS_URL.devUrl;
        break
    case 'test':   // 生产测试
        baseUrl = BASE_URL.testUrl;
        smsUrl = SMS_URL.testUrl;
        wsUrl = WS_URL.testUrl;
        break
    case 'production': // 生产
        baseUrl = BASE_URL.productUrl;
        smsUrl = SMS_URL.productUrl;
        wsUrl = WS_URL.productUrl;
        break
}
// export default baseUrl;
module.exports = {
    baseUrl,
    smsUrl,
    wsUrl
}
